import { styles } from "./styles";
import { IScreenControllerTranslations } from "../../connector/__types__/UIViewController";
import React, { ChangeEvent, useCallback } from "react";
import { Input, Flex, Select } from "antd";
import { useControllers } from "@view/hooks/useControllers";
import { TranslationService } from "@services/translate";
import { Button } from "@shared/controls/Button";
import { Utils } from "@modules/utils";
import { PlusCircleFilled } from "@ant-design/icons";
import { ITranslationsListLocalFilters } from "@viewModels/TranslationsListViewModel/__types__/ITranslationsListViewModel";

const TranslationsHead = (): JSX.Element => {
  const { UIViewController } = useControllers<{
    UIViewController: IScreenControllerTranslations;
  }>();

  const handleSearch = useCallback(
    Utils.debounce((event: ChangeEvent<HTMLInputElement>) => {
      UIViewController.setFilterSearch(event.target.value);
    }, 400),
    []
  );

  const handleSegment = useCallback(
    Utils.debounce((segment: ITranslationsListLocalFilters["segment"]) => {
      UIViewController.setFilterBySegment(
        segment as ITranslationsListLocalFilters["segment"]
      );
    }, 400),
    []
  );

  return (
    <Flex gap="middle" className={styles.wrapper}>
      <Flex gap="middle">
        <Input.Search
          className={styles.search}
          placeholder={TranslationService.t("txt_search_entity", {
            entity: TranslationService.t("txt_translates").toLocaleLowerCase(),
          })}
          onChange={handleSearch}
          allowClear
        />
        <Select
          defaultValue={"api"}
          style={{ width: 200 }}
          onChange={handleSegment}
          options={[
            {
              label: "All",
              value: "",
            },
            {
              label: "Api",
              value: "api",
            },
            {
              label: "Backend",
              value: "messages",
            },
            {
              label: "Frontend",
              value: "frontend",
            },
          ]}
        />
      </Flex>

      <Button
        icon={<PlusCircleFilled />}
        children={TranslationService.t("txt_add_entity", {
          entity: TranslationService.t("txt_translate").toLocaleLowerCase(),
        })}
        type="primary"
        onClick={UIViewController.openTranslationCreateScene}
      />
    </Flex>
  );
};

export default TranslationsHead;
